import { useContext, useState } from "react";
import { UserContext } from "../../components/context/UseContext";
import axios from "../axios";
import { toast } from "sonner";

export const useManageWallet = () => {
  const { profile } = useContext(UserContext);
  const walletId = profile?.wallet?.id;
  const token = localStorage.getItem("arena_xp_token");
  const [walletHistory, setWalletHistory] = useState([]);
  const [balance, setBalance] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [category, setCategory] = useState("all");
  const [value, setValue] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState("");
  const [page, setPage] = useState(1);
  const [loadMorePage, SetLoadMorePage] = useState(false);
  const [lastPage, setLastPage] = useState(0);

  const getBalance = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get("/audiences/wallet/wallet-balance", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (res.status === 200) {
        setIsLoading(false);
        setBalance(res.data.walletBalance);
      }
    } catch (error) {
      setIsLoading(false);
      if (error.status === 404) {
        toast.error("Unable to display balance");
      } else {
        toast.error(error.response.data.message);
      }
    }
  };
  const getWalletHistory = async (page) => {
    try {
      if (page > 1) {
        SetLoadMorePage(true);
      } else setIsLoading(true);
      const res = await axios.get(
        `/account-settings/wallet/${walletId}/transaction-history?page=${page}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      if (res.status === 200) {
        setIsLoading(false);
        SetLoadMorePage(false);
        setWalletHistory((prev) => [...prev, ...res.data.tx_history.data]);
        setLastPage(res.data.tx_history.last_page);
      }
    } catch (err) {
      setIsLoading(false);
      if (err.status === 404) {
        toast.error("Transaction History could not be found");
      } else {
        toast.error(err.response.data.message);
      }
    }
  };
  const handleFilterTransaction = async (category, startDate, endDate) => {
    setIsLoading(true);
    try {
      const res = await axios.post(
        `/account-settings/wallet/${walletId}/filter-transaction`,
        JSON.stringify({
          status: category,
          from_date: startDate,
          to_date: endDate,
        }),
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      if (res.status === 200) {
        setWalletHistory(res.data.data.data);
        setIsLoading(false);
        setStartDate("");
        setEndDate("");
      }
    } catch (error) {
      setIsLoading(false);
      toast.error(error.response.data.message);
    }
  };

  const handleSearchTransaction = async (value) => {
    setIsLoading(true);
    try {
      const res = await axios.post(
        `/account-settings/wallet/${walletId}/search-transaction`,
        JSON.stringify({
          transaction_param: value.toLowerCase(),
        }),
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      if (res.status === 200) {
        setWalletHistory(res.data.data);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      toast.error(error.response.data.message);
    }
  };

  return {
    walletHistory,
    balance,
    isLoading,
    loadMorePage,
    lastPage,
    walletId,
    page,
    setPage,
    category,
    setCategory,
    value,
    setValue,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    getBalance,
    getWalletHistory,
    handleFilterTransaction,
    handleSearchTransaction,
  };
};
